var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-bar'),_c('menu-master'),_c('v-main',[_c('v-row',{style:(_vm.withS)},[_c('v-col',[_c('router-view')],1)],1)],1),_c('v-overlay',{attrs:{"value":_vm.overlay,"opacity":"0.7"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }